import { render, staticRenderFns } from "./BatchVehiclePlate.vue?vue&type=template&id=a7d2aa80&scoped=true"
import script from "./BatchVehiclePlate.vue?vue&type=script&lang=js"
export * from "./BatchVehiclePlate.vue?vue&type=script&lang=js"
import style0 from "./BatchVehiclePlate.vue?vue&type=style&index=0&id=a7d2aa80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d2aa80",
  null
  
)

export default component.exports